export default __webpack_public_path__ + "d6d441b9f2f50c54095a717d5d3664c2.png";